import * as actions from './slice'
import { stackAlert } from '../toast/helpers'

export const getSearchResults = {
  eventName: 'contentSearchTenantContent',
  onSuccess: {
    action: actions.setResults,
    redux: true
  },
  onError: {
    action: stackAlert('Unable to get search results', 'error'),
    redux: true
  }
}

// Same event as getSearchResults, appending instead of replacing — the pattern
// getParentSearchCounts already uses below.
export const getMoreSearchResults = {
  eventName: 'contentSearchTenantContent',
  onSuccess: {
    action: actions.appendResults,
    redux: true
  },
  onError: {
    action: stackAlert('Unable to get more search results', 'error'),
    redux: true
  }
}

export const getSearchSuggestions = {
  eventName: 'contentSearchTenantSuggestion',
  onSuccess: {
    action: actions.setSuggestions,
    redux: true
  },
  onError: {
    action: stackAlert('Unable to get search suggestions', 'error'),
    redux: true
  }
}

export const getUserSearchHistory = {
  eventName: 'searchHistoryGetUser',
  onSuccess: {
    action: actions.setHistory,
    redux: true
  },
  onError: {
    action: stackAlert('Unable to get search history', 'error'),
    redux: true
  }
}

export const getParentSearchCounts = {
  eventName: 'contentSearchTenantContent',
  onSuccess: {
    action: actions.setParentCounts,
    redux: true
  },
  onError: {
    action: stackAlert('Unable to get parent search results', 'error'),
    redux: true
  }
}
